import apiClient from './apiClient';

export interface F116 {
  f116_01: string;  // 付款條件代號
  f116_11: string;  // 條件說明文字
  f116_12: number;  // 付款天數
  f116_13: number;  // 付款條件類別 (1~4)
  f116_14: boolean; // 舊代號標記
  f116_21: number;  // 下單後預付款比例(%)
  f116_22: number;  // 出貨前付款比例(%)
  f116_23: number;  // 出貨後付款比例(%)
  f116_24: number;  // 餘額付款天數
  f116_31: string;  // 詳細說明
  f116_91: string;  // 儲存日期年月
  f116_92: string | null; // 儲存日期
  f116_93: string;  // 儲存時間
}

export interface ListResponse { data: F116[]; total: number; page: number; size: number; }

export const paymentTermsApi = {
  async list(page = 1, size = 100, includeOld = true): Promise<ListResponse> {
    const params: Record<string, string | number | boolean> = { page, size };
    if (includeOld) params.includeOld = 'true';
    return (await apiClient.get('/api/payment-terms', { params })).data;
  },
  async search(keyword: string, page = 1, size = 100, includeOld = true): Promise<ListResponse> {
    const params: Record<string, string | number> = { keyword, page, size };
    if (includeOld) params.includeOld = 'true';
    return (await apiClient.get('/api/payment-terms/search', { params })).data;
  },
  async get(code: string): Promise<F116> {
    return (await apiClient.get(`/api/payment-terms/${encodeURIComponent(code)}`)).data;
  },
  async create(data: Partial<F116>): Promise<F116> {
    return (await apiClient.post('/api/payment-terms', data)).data;
  },
  async update(code: string, data: Partial<F116>): Promise<F116> {
    return (await apiClient.put(`/api/payment-terms/${encodeURIComponent(code)}`, data)).data;
  },
  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/payment-terms/${encodeURIComponent(code)}`);
  },
  async copy(sourceCode: string, newCode: string): Promise<F116> {
    return (await apiClient.post(`/api/payment-terms/${encodeURIComponent(sourceCode)}/copy`, { new_code: newCode })).data;
  },
};
